import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { Button } from "../components/ui/button";
import { Home, Phone } from "lucide-react";

// Sans cette route, toute URL inconnue renvoyait une page blanche en HTTP 200 :
// Google pouvait indexer des adresses erronées. La page est en noindex.
const PageIntrouvable = () => {
  const liens = [
    { nom: "MaPrimeAdapt' : conditions et montants", url: "/maprimeadapt" },
    { nom: "Tester mon éligibilité", url: "/simulateur" },
    { nom: "Adapter ma salle de bain", url: "/salle-de-bain" },
    { nom: "Solutions d'accessibilité", url: "/accessibilite" },
    { nom: "Nous contacter", url: "/contact" },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Seo
        titre="Page introuvable | Transition Énergie France"
        description="Cette page n'existe pas ou a été déplacée. Retrouvez nos informations sur MaPrimeAdapt' et l'adaptation du logement."
        chemin="/404"
        noindex
      />
      <Header />

      <main id="contenu">

      <section className="py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <p className="text-6xl font-bold text-orange-600 mb-4">404</p>
            <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Cette page n'existe pas
            </h1>
            <p className="text-lg text-gray-700 mb-10">
              Le lien que vous avez suivi est peut-être erroné ou la page a été déplacée.
              Voici les pages les plus consultées :
            </p>

            <ul className="text-left inline-block mb-10">
              {liens.map((l) => (
                <li key={l.url}>
                  <Link
                    to={l.url}
                    className="inline-block py-2 text-orange-700 hover:text-orange-800 underline"
                  >
                    {l.nom}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button className="bg-orange-700 hover:bg-orange-800 text-white w-full sm:w-auto">
                  <Home className="mr-2 h-5 w-5" />
                  Retour à l'accueil
                </Button>
              </Link>
              <Button
                variant="outline"
                className="border-2 w-full sm:w-auto"
                onClick={() => {
                  window.location.href = "tel:0939035444";
                }}
              >
                <Phone className="mr-2 h-5 w-5" />
                09 39 03 54 44
              </Button>
            </div>
          </div>
        </div>
      </section>

      </main>

      <Footer />
    </div>
  );
};

export default PageIntrouvable;
